export default __webpack_public_path__ + "static/media/download-app-1.d98b46ca.jpg";